import React, { useEffect, useState } from 'react'
import {
  Grid, Col, Row
} from 'react-bootstrap'
import { default as Plotly } from "plotly.js-basic-dist-min";
import createPlotlyComponent from "react-plotly.js/factory";
import { apiV2 } from 'services/api'
import { useSelector } from 'react-redux';
import { constants } from '../../redux/callTakers/actions'
import { commonConstants } from '../../redux/common/actions'
import { useDispatch } from 'react-redux';
import Card from "../../components/Card/Card.jsx";
import Button from '../../components/CustomButton/CustomButton.jsx'

const { REQUEST } = commonConstants

let Plot = null

const LessonStats = ({ hasAdmin, id }) => {

  const { callTakers } = useSelector(state => state.callTakers)
  const dispatch = useDispatch()

  const [downloading, setDownloading] = useState(false)

  useEffect(() => {
    if (hasAdmin && id) {
        Plot = createPlotlyComponent(Plotly)
        getLessonStats()
    }
    return () => { }
  }, [hasAdmin, id])

  const [lessonStats, setLessonStats] = useState(null)
  const getLessonStats = () => {
    dispatch({ type: constants.FETCH_ALL_CALL_TAKERS + REQUEST, payload: { enabled: true } })

    apiV2.lessons.getStats(id).then((res) => {
      setLessonStats(res)
    })
  }

  const downloadLessonReport = async () => {
    setDownloading(true)

    apiV2.lessons.download(id).then(blob => {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = `Module_${id}_Report.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
    }).finally(() => {
      setDownloading(false)
    })
  }

  const renderPlots = () => {
    let plots = []
    Object.keys(lessonStats?.questionAnswerCounts).forEach((key, index) => {
      const question = lessonStats.questionAnswerCounts[key]
      plots.push(
        <Plot
          key={'plot-'+index}
          style={{ width: "100%", height: "100%" }}
          data={[
            {
              type: 'pie',
              labels: Object.keys(question).map((x) => {
                return 'Answer ' + (parseInt(x)+1)
              }),
              textinfo: "value+percent",
              values: Object.values(question),
            }
          ]}
          layout={{ autosize: true, title: 'Call Taker Answers to Question #' + (index + 1) }}
          />
        )
      })
      return plots
  }

  return (
    <>
    {hasAdmin &&
      <div className='main-content'>
        <Card
          content={
            <Grid fluid>
              <h3 style={{marginBottom: 20}}><b>Module Stats:</b></h3>
              <Button
                onClick={() => downloadLessonReport()}
                bsStyle="primary"
                bsSize="lg"
                disabled={downloading}
              >
                Download Module Report
              </Button>
              <Row style={{marginTop: 20}}>
                <Col xs={12} sm={6}>
                  <h5>
                    <b>{lessonStats && lessonStats.responseCount}</b> out of <b>{callTakers.length}</b> call takers have responded to this module.
                  </h5>
                </Col>
              </Row>
              <Row style={{marginTop: 20}}>
                <Col xs={12} sm={6}>
                  {hasAdmin && Plot && lessonStats &&
                    renderPlots()
                  }
                </Col>
              </Row>
            </Grid>
          }
          />
      </div>
    }
  </>
  )
}

export default LessonStats